/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetPrinterJpkDocumentDto
 */
export interface GetPrinterJpkDocumentDto {
    /**
     * 
     * @type {string}
     * @memberof GetPrinterJpkDocumentDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetPrinterJpkDocumentDto
     */
    jpkId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetPrinterJpkDocumentDto
     */
    printerUid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPrinterJpkDocumentDto
     */
    documentType?: GetPrinterJpkDocumentDtoDocumentTypeEnum | null;
    /**
     * 
     * @type {object}
     * @memberof GetPrinterJpkDocumentDto
     */
    jpkData?: object | null;
    /**
     * 
     * @type {Date}
     * @memberof GetPrinterJpkDocumentDto
     */
    documentTs?: Date | null;
    /**
     * Binary data encoded as base64
     * @type {string}
     * @memberof GetPrinterJpkDocumentDto
     */
    binaryData?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetPrinterJpkDocumentDto
     */
    creationTs?: Date | null;
}


/**
 * @export
 */
export const GetPrinterJpkDocumentDtoDocumentTypeEnum = {
    Paragon: 'Paragon',
    Raport: 'Raport',
    Inne: 'Inne'
} as const;
export type GetPrinterJpkDocumentDtoDocumentTypeEnum = typeof GetPrinterJpkDocumentDtoDocumentTypeEnum[keyof typeof GetPrinterJpkDocumentDtoDocumentTypeEnum];


/**
 * Check if a given object implements the GetPrinterJpkDocumentDto interface.
 */
export function instanceOfGetPrinterJpkDocumentDto(value: object): value is GetPrinterJpkDocumentDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetPrinterJpkDocumentDtoFromJSON(json: any): GetPrinterJpkDocumentDto {
    return GetPrinterJpkDocumentDtoFromJSONTyped(json, false);
}

export function GetPrinterJpkDocumentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPrinterJpkDocumentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'jpkId': json['jpkId'] == null ? undefined : json['jpkId'],
        'printerUid': json['printerUid'] == null ? undefined : json['printerUid'],
        'documentType': json['documentType'] == null ? undefined : json['documentType'],
        'jpkData': json['jpkData'] == null ? undefined : json['jpkData'],
        'documentTs': json['documentTs'] == null ? undefined : (new Date(json['documentTs'])),
        'binaryData': json['binaryData'] == null ? undefined : json['binaryData'],
        'creationTs': json['creationTs'] == null ? undefined : (new Date(json['creationTs'])),
    };
}

export function GetPrinterJpkDocumentDtoToJSON(value?: GetPrinterJpkDocumentDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'jpkId': value['jpkId'],
        'printerUid': value['printerUid'],
        'documentType': value['documentType'],
        'jpkData': value['jpkData'],
        'documentTs': value['documentTs'] == null ? undefined : ((value['documentTs'] as any).toISOString()),
        'binaryData': value['binaryData'],
        'creationTs': value['creationTs'] == null ? undefined : ((value['creationTs'] as any).toISOString()),
    };
}

